/**
 *
 * @module serviceEndpoint
 *
 */

import HttpMethod from './httpMethod';

/**
 *
 * @class ServiceEndpoint
 * @desc Provides configuration information for a service endpoint (i.e. link).
 *
 */
export default class ServiceEndpoint {

    /**
     *
     * @param {String} rel
     * @param {String} href
     * @param {Integer} ttl
     * @param {Integer} timeout
     * @param {Boolean} templated
     * @param {String} [method=HttpMethod.Get]
     * @param {Object} [headers=null]
     *
     */
    constructor(rel, href, ttl, timeout, templated, method = HttpMethod.GET, headers = null) {

        /**
         *
         * @access public
         * @type {String}
         *
         */
        this.rel = rel;

        /**
         *
         * @access public
         * @type {String}
         * @desc Gets or sets the URL for the service request.
         *
         */
        this.href = href;

        /**
         *
         * @access public
         * @type {Integer}
         *
         */
        this.ttl = ttl;

        /**
         *
         * @access public
         * @type {Integer}
         * @desc Gets or sets the timeout for the service request.
         *
         */
        this.timeout = timeout;

        /**
         *
         * @access public
         * @type {Boolean}
         * @desc Gets or sets a value that indicates whether or not the href requires
         * template string substitution prior to sending the service request.
         *
         */
        this.templated = templated;

        /**
         *
         * @access public
         * @type {String}
         * @desc Gets or sets the HTTP method that should be used for requests to the endpoint.
         *
         */
        this.method = method;

        /**
         *
         * @access public
         * @type {Object}
         * @desc Gets or sets the headers to append to the service request.
         *
         */
        this.headers = headers;

    }

}



// WEBPACK FOOTER //
// ./src/services/configuration/serviceEndpoint.js